const ProductsCard = ({ name, image, description, backgroundColor, link }) => {
  return (
    <a href={link} target="_blank">
      <div
        className={`rounded-[12px] bg-white border border-[#F5F7FA] p-[10px] flex flex-col gap-4 shadow-[0px_17.82px_24.3px_0px_#8C96A91A,0px_5.67px_4.86px_0px_#8C96A91F,0px_0px_0px_4.86px_#FFFFFF]`}
      >
        <div
          className={`w-full h-[190px] flex justify-center items-center rounded-[12px] ${backgroundColor}`}
        >
          <img src={image} alt={name} />
        </div>
        <div className="flex flex-col gap-2 font-medium xl:min-h-[110px] lg:min-h-[158px] md:min-h-[120px]">
          <h3 className="text-sm -tracking-[0.22px]  ">{name}</h3>
          <p className="text-xs text-[#99A0AE]  -tracking-[0.07px] pb-1">
            {description}
          </p>
        </div>
      </div>
    </a>
  );
};

export default ProductsCard;
